import React from 'react'

import _ from 'lodash'

import UserActions from '../../actions/UserActions.js'
import LoginActions from '../../actions/LoginActions.js'

import {Popup, P, H5, Alert, Button, Modal, ModalHeader, ModalActions, H6} from '../UI/index.js'
import Address from '../addresses/Address.js'
import {formSpacing, Check, FormRow, FormStack, Input, Select} from '../UI/forms/index.js'
import NewUser from './NewUser.js'
import t from 'src/helpers/Languages.js'
import {getAvailableBranches} from 'src/utils/branches.js'

class UserModal extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            modalIsOpen: false,
            user: NewUser(),
            validation: {},
            loading: false,
            error: '',
            mailLoading: false,
            mailMessage: '',
            mailError: ''
        }

        this.state = structuredClone(this.initialState)
    }

    open(user) {
        const {reseller} = this.props

        user = user ? structuredClone(user) : NewUser()

        // settings is not a reseller module, so it's never reset by the reseller permissions
        Object.keys(reseller.permissions).map((permission) => {
            if (!reseller.permissions[permission] && permission !== 'settings') {
                user.permissions[permission] = false
            }
        })

        // remove any branchIds that are not available for the reseller
        user.branchIds = user.branchIds?.filter((branchId) => reseller.settings.branches?.find((branch) => branch.id === branchId)) || []

        console.log(user)

        this.setState({
            modalIsOpen: true,
            originalUser: structuredClone(user),
            user
        })
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeValue(path, event) {
        const {user} = this.state

        if (path === 'email') {
            event.target.value = event.target.value.toLowerCase().replace(/\s+/g, '')
        }

        _.set(user, path, event.target.value)
        this.setState({user})
    }

    onChangeValues(path, event) {
        const {user} = this.state
        _.set(user, path, event.target.values)
        this.setState({user})
    }

    onChangeAddress(address) {
        const {user} = this.state
        user.name = address.name
        user.address = address
        this.setState({user})
    }

    onChangeSettingsValue(key, event) {
        const {user} = this.state
        user.settings[key] = event.target.value
        this.setState({user})
    }

    onChangePermission(key, event) {
        const {user} = this.state
        user.permissions[key] = event.target.checked
        this.setState({user})
    }

    async onChangeIsOwner(event) {
        const {user} = this.state
        const checked = event.target.checked

        if (checked) {
            if (!await this.popup.open(t('warning'), 'Het eigenaarschap van dit account wordt overgedragen naar deze gebruiker. Weet je zeker dat je door wilt gaan?')) return
            this.popup.close()
        }

        user.isOwner = checked
        this.setState({user})
    }

    onValidate() {
        const {user} = this.state
        const validation = {}
        let id = ''
        let valid = true

        if (!user.email) {
            id = 'email'
            validation.email = true
            valid = false
        }

        if (!user.name) {
            id = 'name'
            validation.name = true
            valid = false
        }

        if (!valid) {
            const element = document.getElementById(id)
            if (element) {
                element.focus()
            }
        }

        this.setState({validation})
        return valid
    }

    onSendWelcomeMail() {
        const {user} = this.state
        this.setState({mailLoading: true, mailMessage: '', mailError: ''})

        let promise = Promise.resolve()

        if (!user._id) {
            this.setState({loading: true, error: ''})

            promise = new Promise((resolve, reject) => {
                UserActions.create(user, (err) => {
                    if (err) {
                        reject(err)
                    } else {
                        resolve()
                    }
                })
            })
        }

        promise.then(() => {
            LoginActions.sendUserWelcomeMail(user, (err, response) => {
                if (err) {
                    this.setState({mailLoading: false, mailError: err})
                } else {
                    if (!user._id) {
                        this.close()
                    } else {
                        this.setState({mailLoading: false, mailMessage: response})
                    }
                }
            })
        }).catch((err) => {
            this.setState({loading: false, error: err, mailLoading: false})
        })
    }

    onReset2FA() {
        const {user} = this.state
        this.popup.open('Reset 2FA methode', 'De gebruiker zal de 2FA methode opnieuw moeten activeren. Inloggen met de huidige methode zal niet meer mogelijk zijn. Weet je zeker dat je door wil gaan?', () => {
            UserActions.reset2FA(user, (err, updatedUser) => {
                if (err) {
                    this.setState({error: err})
                } else {
                    this.setState({user: updatedUser}, () => {
                        this.popup.close()
                    })
                }
            })
        })
    }

    async onSubmit(event) {
        event.preventDefault()

        const {user, originalUser} = this.state
        const {reseller, activeUser} = this.props

        // restore branches that the current user does not have access to, so they are not removed when saving
        const unavailableBranches = originalUser.branchIds?.filter((branchId) => !getAvailableBranches(reseller, activeUser).find((branch) => branch.id === branchId)) || []
        user.branchIds = _.uniq([...(user.branchIds || []), ...unavailableBranches])

        if (this.onValidate()) {
            if (user._id) {
                if (activeUser._id !== user._id && JSON.stringify(user.branchIds) !== JSON.stringify(originalUser.branchIds)) {
                    if (!await this.popup.open(t('warning'), 'Wijzigingen aan vestigingen worden pas doorgevoerd bij de volgende login van de gebruiker. Weet je zeker dat je door wil gaan?')) return
                    this.popup.close()
                }

                UserActions.edit(user, (err) => {
                    if (!err) {
                        if (activeUser._id === user._id) {
                            // refresh the current user in the store, so the changes are reflected immediately
                            LoginActions.getAccount(user)
                        }
                    }
                    this.response(err)
                })
            } else {
                UserActions.create(user, this.response.bind(this))
            }
        }
    }

    response(err) {
        if (err) {
            this.setState({error: err, loading: false})
        } else {
            this.close()
        }
    }

    render() {
        const {modalIsOpen, user, validation, loading, error, mailLoading, mailMessage, mailError} = this.state
        const {reseller, activeUser} = this.props

        const showShiftbaseDepartment = reseller.settings.shifts?.shiftbase?.departmentConnectedTo === 'user' && !!user.meta?.shiftbaseUserId
        const showShiftbaseTeam = reseller.settings.shifts?.shiftbase?.teamConnectedTo === 'user' && !!user.meta?.shiftbaseUserId

        return (
            <Modal show={modalIsOpen} onClose={this.close.bind(this)}>
                <ModalHeader title={user._id ? 'Bewerk gebruiker' : 'Nieuwe gebruiker'} onClose={this.close.bind(this)} />

                <form onSubmit={this.onSubmit.bind(this)}>
                    {getAvailableBranches(reseller).length > 0 &&
                        <FormRow style={{marginBottom: formSpacing.rowGap}}>
                            <Select
                                label={t('branches')}
                                info='Kies welke vestingen deze gebruiker kan selecteren. Gebruikers met permissie tot Instellingen krijgen nieuwe vestigingen altijd automatisch toegevoegd.'
                                values={(user.isOwner ? getAvailableBranches(reseller).map((branch) => branch.id) : user.branchIds) || []}
                                options={getAvailableBranches(reseller).map((branch) => {
                                    return {value: branch.id, title: branch.name}
                                })}
                                onChange={this.onChangeValues.bind(this, 'branchIds')}
                                disabled={user.isOwner}
                            />

                            <div style={{flex: 1}} />
                        </FormRow>
                    }

                    <Address
                        address={user.address}
                        noTAV
                        onChange={this.onChangeAddress.bind(this)}
                        ref={(ref) => this.address = ref}
                    />

                    <FormRow style={{marginTop: formSpacing.section + formSpacing.rowGap, marginBottom: formSpacing.section + formSpacing.rowGap}}>
                        <Input
                            label='Telefoon'
                            value={user.phone}
                            onChange={this.onChangeValue.bind(this, 'phone')}
                        />

                        <Input
                            id='email'
                            label='Emailadres'
                            value={user.email}
                            isInvalid={validation.email}
                            onChange={this.onChangeValue.bind(this, 'email')}
                        />
                    </FormRow>

                    {(reseller.settings.mfaWebEnabled || reseller.settings.mfaAppEnabled) && activeUser.isOwner && (
                        <div style={{marginBottom: 24}}>
                            <H6 style={{marginBottom: 12}}>Tweestapsverificatie</H6>
                            <P>Tweestapsverificatie actief: {user.mfaEnabled ? 'Ja' : 'Nee'}</P>
                            {user.mfaEnabled && (
                                <Button
                                    style={{marginTop: 12}}
                                    onClick={this.onReset2FA.bind(this)}
                                    variant='outline-white'
                                >
                                    Reset 2FA
                                </Button>
                            )}
                        </div>
                    )}

                    <H5 style={{marginBottom: 24}}>Permissies</H5>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                        marginBottom: 10
                    }}
                    >
                        {['orders', 'parcels', 'shifts', 'subscriptions', 'users', 'vehicles', 'customers', 'invoices', 'settings', 'parcelOCR', 'analytics'].map((permission) => {
                            if (reseller.permissions[permission] || permission === 'settings') {
                                return (
                                    <Check
                                        key={permission}
                                        style={{width: '33%'}}
                                        label={labels[permission]}
                                        disabled={!activeUser.permissions[permission]}
                                        checked={user.permissions[permission]}
                                        onChange={this.onChangePermission.bind(this, permission)}
                                    />
                                )
                            }
                        })}

                        {activeUser.isOwner &&
                            <Check
                                style={{width: '33%'}}
                                label='Eigenaar'
                                disabled={!activeUser.isOwner}
                                checked={!!user.isOwner}
                                onChange={this.onChangeIsOwner.bind(this)}
                            />
                        }
                    </div>

                    {reseller.settings.shifts?.shiftbase?.enabled &&
                        <>
                            <H5 style={{marginBottom: 24, marginTop: 24}}>Shiftbase</H5>

                            <FormStack style={{marginBottom: formSpacing.section + formSpacing.rowGap}}>
                                <Select
                                    label='Shiftbase gebruiker'
                                    fetch={async () => {
                                        const response = await fetch('https://api.shiftbase.com/api/users', {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Accept': 'application/json',
                                                'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                            }
                                        })

                                        const shiftbaseUsers = (await response.json())?.data || []

                                        return shiftbaseUsers.map((user) => {
                                            return {
                                                title: user.User.name,
                                                value: user.User.id
                                            }
                                        })
                                    }}
                                    value={user.meta?.shiftbaseUserId || ''}
                                    onChange={(event) => this.onChangeValue('meta.shiftbaseUserId', event)}
                                    allowEmpty
                                />

                                {(showShiftbaseDepartment || showShiftbaseTeam) &&
                                    <FormRow>
                                        {showShiftbaseDepartment &&
                                            <Select
                                                label='Shiftbase afdeling'
                                                fetch={async () => {
                                                    const response = await fetch(`https://api.shiftbase.com/api/users/${user.meta?.shiftbaseUserId}`, {
                                                        headers: {
                                                            'Content-Type': 'application/json',
                                                            'Accept': 'application/json',
                                                            'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                                        }
                                                    })

                                                    const shiftbaseUser = (await response.json())?.data || {}

                                                    const response2 = await fetch('https://api.shiftbase.com/api/departments', {
                                                        headers: {
                                                            'Content-Type': 'application/json',
                                                            'Accept': 'application/json',
                                                            'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                                        }
                                                    })

                                                    const shiftbaseDepartments = (await response2.json())?.data || []

                                                    return shiftbaseDepartments.map((department) => {
                                                        if (shiftbaseUser.Team.find((team) => team.department_id === department.Department.id)) {
                                                            return {
                                                                title: department.Department.name,
                                                                value: department.Department.id
                                                            }
                                                        }
                                                    })
                                                }}
                                                fetchTrigger={user.meta?.shiftbaseUserId}
                                                value={user.meta?.shiftbaseDepartmentId || ''}
                                                onChange={(event) => this.onChangeValue('meta.shiftbaseDepartmentId', event)}
                                                allowEmpty
                                            />
                                        }

                                        {showShiftbaseTeam ?
                                            <Select
                                                label='Shiftbase team'
                                                fetch={async () => {
                                                    const response = await fetch(`https://api.shiftbase.com/api/users/${user.meta?.shiftbaseUserId}`, {
                                                        headers: {
                                                            'Content-Type': 'application/json',
                                                            'Accept': 'application/json',
                                                            'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                                        }
                                                    })

                                                    const shiftbaseUser = (await response.json())?.data || {}

                                                    return shiftbaseUser.Team?.map((team) => {
                                                        if (reseller.settings.shifts.shiftbase.departmentConnectedTo !== 'user' || team.department_id === user.meta?.shiftbaseDepartmentId) {
                                                            return {
                                                                title: team.name,
                                                                value: team.id
                                                            }
                                                        }
                                                    }) || []
                                                }}
                                                fetchTrigger={user.meta?.shiftbaseUserId + user.meta?.shiftbaseDepartmentId}
                                                value={user.meta?.shiftbaseTeamId || ''}
                                                onChange={(event) => this.onChangeValue('meta.shiftbaseTeamId', event)}
                                                allowEmpty
                                            /> :
                                            <div style={{flex: 1}} />
                                        }
                                    </FormRow>
                                }
                            </FormStack>
                        </>
                    }

                    {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}
                    {mailMessage && <Alert style={{marginBottom: 6}} dismissible variant='success'>{mailMessage}</Alert>}
                    {mailError && <Alert style={{marginBottom: 6}} dismissible variant='danger'>{mailError}</Alert>}

                    <ModalActions>
                        <Button variant='text' loading={mailLoading} onClick={this.onSendWelcomeMail.bind(this)}>
                            Verstuur welkomstmail
                        </Button>

                        <Button loading={loading} type='submit'>
                            Opslaan
                        </Button>
                    </ModalActions>
                </form>
                <Popup ref={(ref) => this.popup = ref} />
            </Modal>
        )
    }
}

const labels = {
    orders: 'Ritten',
    parcels: 'Zendingen',
    shifts: 'Diensten',
    subscriptions: 'Abonnementen',
    customers: 'Klanten',
    invoices: 'Facturen',
    users: 'Gebruikers',
    vehicles: 'Voertuigen',
    // paychecks: 'Urenregistratie',
    settings: 'Instellingen',
    parcelOCR: 'Zendinginvoer OCR',
    analytics: 'Rapportage'
}

export default UserModal
